import React from 'react';
import Helmet from 'react-helmet';

const TitleWeb = ({ title }) => {
    const defaultTitle = 'Social Master';
    return (
        <Helmet>
            <title>{title ? title : defaultTitle}</title>
        </Helmet>
    );
};

export default TitleWeb;
